import { css, theme } from '../theme';
import { withPublicAssets, IpublicAssets } from '@utils/url.utils';

const getFonts = ({ publicAssets }: { publicAssets: IpublicAssets }) => css`
    @font-face {
        src: url(${publicAssets('/fonts/AP/PeugeotNew-Light.ttf')}) format('truetype');
        font-family: ${theme.fonts.fontBase};
        font-weight: ${theme.fontWeights.textLight};
        font-style: normal;
    }
    @font-face {
        src: url(${publicAssets('/fonts/AP/PeugeotNew-LightItalic.ttf')}) format('truetype');
        font-family: ${theme.fonts.fontBase};
        font-weight: ${theme.fontWeights.textLight};
        font-style: italic;
    }
    @font-face {
        src: url(${publicAssets('/fonts/AP/PeugeotNew-Regular.ttf')}) format('truetype');
        font-family: ${theme.fonts.fontBase};
        font-weight: ${theme.fontWeights.textRegular};
        font-style: normal;
    }
    @font-face {
        src: url(${publicAssets('/fonts/AP/PeugeotNew-Italic.ttf')}) format('truetype');
        font-family: ${theme.fonts.fontBase};
        font-weight: ${theme.fontWeights.textMedium};
        font-style: italic;
    }
    @font-face {
        src: url(${publicAssets('/fonts/AP/PeugeotNew-Bold.ttf')}) format('truetype');
        font-family: ${theme.fonts.fontBase};
        font-weight: ${theme.fontWeights.textBold};
        font-style: normal;
    }
    @font-face {
        src: url(${publicAssets('/fonts/AP/PeugeotNew-Bold.ttf')}) format('truetype');
        font-family: ${theme.fonts.fontV2};
        font-weight: ${theme.fontWeights.textBold};
        font-style: normal;
    }
    @font-face {
        src: url(${publicAssets('/fonts/AP/PeugeotNew-BoldItalic.ttf')}) format('truetype');
        font-family: ${theme.fonts.fontBase};
        font-weight: ${theme.fontWeights.textBold};
        font-style: italic;
    }
`;

export default withPublicAssets(getFonts)();
